module.exports = __webpack_public_path__ + "ba.svg?726a63bdd3cf84a489ff0cca37cd4e34";